import { useState, useEffect } from "react";
import Loading from "@components/loading/Loading";
import { ENUM_SCORES } from "@enum/contracts.enum";
import axios from "axios";
const NftsQueue = ({ reservation, reservationState }: any) => {
  const [gangstabetInfo, setGanstabetInfo] = useState<any>([]);
  const getWindowSize = () => {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  };
  const [windowSize, setWindowSize] = useState<{
    innerWidth: number;
    innerHeight: number;
  }>(getWindowSize());
  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize(getWindowSize());
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const redirectToRespectiveProfile = (id: String) => {
    window.open(`https://gangstabet.io/profile/${id}`, "_blank");
  };

  useEffect(() => {
    setGanstabetInfo([]);
    const promisesArray: any = [];
    reservation.map((value: any, index: any) => {
      const gbInfo = axios.get(
        "https://api.gangstabet.io/api/public/token/" + value.reservedNftId
      );
      promisesArray.push(gbInfo);
    });
    console.log("reservation", reservation);
    Promise.all(promisesArray).then((res: any) => {
      setGanstabetInfo(res);
    });
  }, [reservationState]);

  return (
    <>
      {windowSize.innerWidth > 768 ? (
        <div className="nftQueue">
          <h3 className="queue-heading">GangstaBets in Queue</h3>
          {gangstabetInfo.length > 0 ? (
            <div className="queue-main-wrapper">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>GangstaBet</th>
                    <th>Reserved by</th>
                    <th>TxHash</th>
                  </tr>
                </thead>

                <tbody>
                  {reservation.map((val: any, key: any) => {
                    return (
                      <>
                        {!Boolean(Number(val.minted)) && (
                          <tr key={key}>
                            <td>
                              <img
                                onClick={() => {
                                  redirectToRespectiveProfile(
                                    val.reservedNftId
                                  );
                                }}
                                className="clickable-queue-td"
                                width={25}
                                src={gangstabetInfo[key]?.data.image_url}
                                alt={`img-${key}`}
                              />
                            </td>
                            <td>
                              <span
                                onClick={() => {
                                  redirectToRespectiveProfile(
                                    val.reservedNftId
                                  );
                                }}
                                className="clickable-queue-td"
                              >
                                {gangstabetInfo[key]?.data.name}
                              </span>
                            </td>
                            <td>
                              <span
                                onClick={() => {
                                  redirectToRespectiveProfile(
                                    val.reservedNftId
                                  );
                                }}
                                className="clickable-queue-td"
                              >
                                {val.owner.slice(0, 5)}...{" "}
                                {val?.owner.slice(-3)}
                              </span>
                            </td>
                            <td>
                              <span
                                className="clickable-queue-td"
                                onClick={() => {
                                  window.open(
                                    `${ENUM_SCORES.ICON_TRACKER}/0x${val.txHash}`
                                  );
                                }}
                              >
                                0x{val.txHash.slice(0, 3)}...
                                {val?.txHash.slice(-3)}
                              </span>
                            </td>
                          </tr>
                        )}
                      </>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="queue-loading">
              <Loading width="20%" />
            </div>
          )}
        </div>
      ) : (
        <div className="queue-sm-wrapper">
          <h3 className="queue-heading">GangstaBets in Queue</h3>
          {gangstabetInfo.length > 0 ? (
            reservation.map((val: any, key: any) => {
              return (
                <>
                  {!Boolean(Number(val.minted)) && (
                    <div key={key} className="queue-sm">
                      <img
                        onClick={() => {
                          redirectToRespectiveProfile(val.reservedNftId);
                        }}
                        className="clickable-queue-td"
                        src={gangstabetInfo[key]?.data.image_url}
                        alt={`img-${key}`}
                        width={"62px"}
                      />
                      <div className="queue-sm-text">
                        <div className="queue-sm-name">
                          <p className="queue-name-label">GangstaBet:</p>
                          <p
                            onClick={() => {
                              redirectToRespectiveProfile(val.reservedNftId);
                            }}
                            className="queue-name-value clickable-queue-td"
                          >
                            {gangstabetInfo[key]?.data.name}
                          </p>
                        </div>
                        <div className="queue-sm-tx">
                          <p className="queue-tx-label">TxHash:</p>
                          <p
                            className="queue-tx-value clickable-queue-td"
                            onClick={() => {
                              window.open(
                                `${ENUM_SCORES.ICON_TRACKER}/0x${val.txHash}`
                              );
                            }}
                          >
                            0x{val?.txHash.slice(0, 3)}...
                            {val?.txHash.slice(-3)}
                          </p>
                        </div>
                      </div>
                      <div className="queue-sm-reserved clickable-queue-td">
                        <p className="queue-res-label">Reserved by:</p>
                        <p
                          onClick={() => {
                            redirectToRespectiveProfile(val.reservedNftId);
                          }}
                          className="queue-res-value clickable-queue-td"
                        >
                          {val?.owner.slice(0, 5)}... {val?.owner.slice(-3)}
                        </p>
                      </div>
                    </div>
                  )}
                </>
              );
            })
          ) : (
            <div className="queue-loading">
              <Loading width="20%" />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default NftsQueue;
